import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiResponse } from '@mobileia/core';
import { MiaAuthHttpService, AuthenticationService } from '@mobileia/authentication';
import { CartItem } from '../entities/cart-item';
import { environment } from 'src/environments/environment';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CartService extends MiaAuthHttpService {

  static KEY_FINGERPRINT = 'key_fingerprint';

  fingerprintCurrent = '';
  items = new BehaviorSubject<Array<CartItem>>([]);

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService,
    protected localStorage: LocalStorage
  ) {
    super(http, authService);
    this.loadFingerprint().subscribe();
  }

  sumQuantity(cart: CartItem): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'cart/sum', { fingerprint: this.fingerprintCurrent, cart_id: cart.id })
    .pipe(map(data => {

      if (data.success) {
        // Buscar item
        let cartList = this.items.value;
        for (const cartIt of cartList) {
          if(cartIt.id == cart.id){
            cartIt.quantity++;
          }
        }
        this.items.next(cartList);
      }

      return data;
    }));
  }

  minQuantity(cart: CartItem): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'cart/min', { fingerprint: this.fingerprintCurrent, cart_id: cart.id })
    .pipe(map(data => {

      if (data.success) {
        // Buscar item
        let cartList = this.items.value;
        for (const cartIt of cartList) {
          if(cartIt.id == cart.id){
            cartIt.quantity--;
          }
        }
        this.items.next(cartList);
      }

      return data;
    }));
  }

  clean() {
    this.items.next([]);
  }

  removeItem(cart: CartItem): Observable<ApiResponse<boolean>> {
    return this.postObject(environment.baseUrl + 'cart/remove', { fingerprint: this.fingerprintCurrent, cart_id: cart.id })
    .pipe(map(data => {

      if (data.success) {
        // Eliminar item del listado
        let cartList = this.items.value;
        let index = cartList.indexOf(cart);
        if (index > -1) {
          cartList.splice(index, 1);
        }
        this.items.next(cartList);
      }

      return data;
    }));
  }

  addItem(productId: number, childId: number, quantity: number): Observable<ApiResponse<CartItem>> {
    if(this.localStorage.getItem)
    return this.postObject(environment.baseUrl + 'cart/add',
    { fingerprint: this.fingerprintCurrent, product_id: productId, childId: childId, quantity: quantity }).pipe(
      map(data => {
        if (data.success) {
          // verificar si ya tiene fingerprint
          if (this.fingerprintCurrent == '') {
            this.fingerprintCurrent = data.response.fingerprint;
            this.saveFingerprint(this.fingerprintCurrent);
          }

          // Crear respueta
          let newResponse = new ApiResponse<CartItem>();
          newResponse.success = data.success;
          newResponse.response = data.response.item;

          // Agregar al carrito
          let cart = this.items.value;
          // Verificar si ya existe este producto
          let exist = false;
          for (const c of cart) {
            if (c.product_id == data.response.item.product_id) {
              c.quantity++;
              exist = true;
              break;
            }
          }
          if (!exist) {
            cart.push(data.response.item);
          }
          this.items.next(cart);

          return newResponse;
        }

        return data;
      })
    );
  }

  fetchList(): Observable<ApiResponse<Array<CartItem>>> {
    return this.postObject(environment.baseUrl + 'cart/list', { fingerprint: this.fingerprintCurrent }).pipe(map(data => {

      if (data.success) {
        this.items.next(data.response);
      }

      return data;
    }));
  }

  saveFingerprint(fingerprint: string) {
    this.localStorage.setItem(CartService.KEY_FINGERPRINT, fingerprint).subscribe(d => {});
  }

  loadFingerprint(): Observable<string> {
    return this.localStorage.getItem<string>(CartService.KEY_FINGERPRINT).pipe(
      map(data => {
        if (data == null || data === '' || data === undefined) {
          return '';
        }
        this.fingerprintCurrent = data as string;
        return this.fingerprintCurrent;
      })
    );
  }
}
